module.exports = __webpack_public_path__ + "static/media/PitchYourProduct.ca9bb883.png";